"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Application = void 0;
var bernie_analytics_1 = require("bernie-analytics");
var queryString = require("query-string");
var React = require("react");
var react_router_1 = require("react-router");
var bernie_core_1 = require("bernie-core");
var _1 = require(".");
var loading_spinner_1 = require("./loading-spinner");
var bernie_core_2 = require("bernie-core");
var render_status_1 = require("./render-status");
var experiment_context_1 = require("@shared-ui/experiment-context");
var page_context_1 = require("@bernie/page-context");
var react_1 = require("react");
var routeChangeCallback = function () {
    (0, bernie_analytics_1.analyticsChangeCallback)();
};
exports.Application = (0, bernie_core_1.logger)('Application')(function (props) {
    /**
     * Escape hatch fallback content. In the event that the application breaks on initial hydration,
     * there is an issue where the app will end up with a blank DOM because React already cleared it.
     * This is a placeholder for content to replace the DOM in the event the error occurs.
     * This will allow the page to still be rendered for the user and allow them to progress.
     *
     * @static
     * @type {string}
     * @memberof Application
     */
    exports.Application.fallbackContent = '';
    var markName = 'PWA Mounted';
    bernie_analytics_1.performanceMetrics.mark(markName);
    var startTime = bernie_analytics_1.performanceMetrics.findMark(markName).startTime;
    var logger = props.logger;
    if (typeof window !== 'undefined') {
        var content = document.getElementById(props.applicationContainerId);
        exports.Application.fallbackContent = content ? content.innerHTML : '';
    }
    // This logger should be a ClientLogger that contains a performance function
    // It is normally provided through bernie-client, but this module doesn't have
    // a dependency on bernie-client, so we have to validate the logger includes
    // the `performance` function
    (0, react_1.useEffect)(function () {
        if (startTime && logger['performance']) {
            logger['performance']({ hydration: startTime });
        }
    });
    var pageDataContext = (0, page_context_1.usePageData)().pageDataContext;
    var firstRender = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(function () {
        // Avoid running this useEffect on first render
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        var nextLocation = props.location || {};
        routeChangeCallback();
        var nextController = (0, bernie_core_2.matchRoute)(props.routes, nextLocation.pathname, { baseUrl: pageDataContext.baseUrl });
        pageDataContext.pageId = nextController.route ? nextController.route.pageId : '';
    }, [props.location.pathname]);
    return (React.createElement(_1.ErrorBoundary, { logger: logger, label: 'app.render.errorboundary', fallback: fallback },
        React.createElement(experiment_context_1.Experiment, { name: "EXPEDIA_BRAND_REFRESH" },
            React.createElement(experiment_context_1.ExperimentControl, null),
            React.createElement(experiment_context_1.ExperimentVariant, { bucket: 1 })),
        React.createElement(_1.LayerManager, null,
            React.createElement(react_router_1.Switch, null, mapRoutes())),
        React.createElement(render_status_1.RenderStatus, null)));
    function fallback() {
        var fallbackProps = {
            dangerouslySetInnerHTML: {
                __html: exports.Application.fallbackContent,
            },
        };
        return React.createElement("div", __assign({}, fallbackProps));
    }
    function mapRoutes() {
        var query = queryString.parse(props.location.search || '');
        //Double & symbols result in an erroneous 'empty string' key.
        delete query[''];
        return props.routes.map(function (route, index) {
            var proxyProps = {
                path: route.path,
                exact: route.exact,
                render: function (props) {
                    var Component = route.component;
                    var location = __assign(__assign({}, props.location), { params: (props.match && props.match.params) || {}, query: query });
                    return (React.createElement(Component, __assign({ loadingState: React.createElement(loading_spinner_1.LoadingSpinner, null), route: route }, props, { location: location, history: props.history })));
                },
            };
            return React.createElement(react_router_1.Route, __assign({}, proxyProps, { key: route.routeName || index }));
        });
    }
});
//# sourceMappingURL=application.js.map